export default __webpack_public_path__ + "static/media/pt-title-en.5785f92e.webp";